import { isTruthy } from '@core/helpers/boolean';
import { arePlayerParams, areStoryblockParams } from '@core/types';
import { PlayerModalPosition } from '../components/PlayerModal';
import { useStore } from '../store';
import { LayoutOrientation, usePlayerLayout, VideoOrientation, } from './usePlayerLayout';
/**
 * Determines position for PlayerModal.
 *
 * @param position Custom position set by PlayerModal's parent
 * @returns Calculated position for a given layout
 */
export function usePlayerModalWrapperPosition(position) {
    const { layoutOrientation, videoOrientation } = usePlayerLayout();
    const params = useStore((state) => state.params);
    if ((areStoryblockParams(params) || arePlayerParams(params)) &&
        isTruthy(params?.cover)) {
        return PlayerModalPosition.COVER;
    }
    else if (layoutOrientation === LayoutOrientation.LANDSCAPE &&
        videoOrientation === VideoOrientation.VERTICAL) {
        return position ?? PlayerModalPosition.CENTER;
    }
    else if (layoutOrientation === LayoutOrientation.LANDSCAPE &&
        videoOrientation === VideoOrientation.HORIZONTAL) {
        return position ?? PlayerModalPosition.COVER;
    }
    return PlayerModalPosition.COVER;
}
